import { useLocation } from "react-router-dom";
import { getPortalBasePath } from "../utils/portalKind";

/**
 * Returns "/partner" when the current URL is under the /partner alias,
 * otherwise "/affiliate". Used for tab links, logo/login/logout targets and
 * returnTo values so a user stays on the prefix they entered with.
 */
export const usePortalBasePath = () => {
  const location = useLocation();
  return getPortalBasePath(location?.pathname);
};

export default usePortalBasePath;
